import React from 'react';
import { Table, Button } from 'react-bootstrap';

const ReportsTable = ({
  reportData,
  currentReportTitle,
  selectedReports,
  onCheckboxChange,
  onPreview,
  onDownload
}) => {
  // Determine if the current report is one of the special ones.
  const isSpecialReport =
    currentReportTitle.trim() === "BIR 2306 Request Letter" ||
    currentReportTitle.trim() === "Closure of Registry Service / Payment Account" ||
    currentReportTitle.startsWith("Consent Solicitation") ||
    currentReportTitle.trim() === "Credit Letter";

  // Fallback condition for Tax Adjustment (if needed)
  const isTaxAdjustment = currentReportTitle === "Tax Adjustment Letter";

  return (
    <Table striped bordered hover>
      <thead>
        {isSpecialReport ? (
          <tr>
            <th style={{ width: '60%' }}>Report Name</th>
            <th style={{ width: '20%' }}>Status</th>
            <th style={{ width: '20%' }}>Action</th>
          </tr>
        ) : (
          <tr>
            <th style={{ width: '5%' }}></th>
            {isTaxAdjustment ? (
              <>
                <th style={{ width: '30%' }}>BPID</th>
                <th style={{ width: '30%' }}>Type of Tax Adjustment</th>
              </>
            ) : (
              <th style={{ width: '35%' }}>Data as of</th>
            )}
            <th style={{ width: '30%' }}>Status</th>
            <th style={{ width: '30%' }}>Action</th>
          </tr>
        )}
      </thead>
      <tbody>
        {reportData.length > 0 ? (
          reportData.map((report) =>
            isSpecialReport ? (
              <tr key={report.id}>
                <td>{report.reportTitle || '-'}</td>
                <td>{report.status || '-'}</td>
                <td>
                  {report.status === 'Reports Available' ? (
                    <>
                      <Button variant="primary" onClick={() => onPreview(report)}>
                        Preview
                      </Button>
                      <Button variant="primary" onClick={() => onDownload(report)}>
                        Download
                      </Button>
                    </>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            ) : (
              <tr key={report.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedReports.some((selected) => selected.id === report.id)}
                    onChange={() => onCheckboxChange(report)}
                    disabled={report.status !== '-'}
                  />
                </td>
                {isTaxAdjustment ? (
                  <>
                    <td>{report.bpId || '-'}</td>
                    <td>{report.taxAdjustmentType || '-'}</td>
                  </>
                ) : (
                  <td>{report.issuerRequestDate || 'No date selected'}</td>
                )}
                <td>{report.status || '-'}</td>
                <td>
                  {report.status === 'Reports Available' ? (
                    <>
                      <Button variant="primary" onClick={() => onPreview(report)}>
                        Preview
                      </Button>
                      <Button variant="primary" onClick={() => onDownload(report)}>
                        Download
                      </Button>
                    </>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            )
          )
        ) : (
          <tr>
            <td colSpan={isSpecialReport ? 3 : isTaxAdjustment ? 5 : 4}>No reports available</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default ReportsTable;
